module.exports = __webpack_public_path__ + "static/media/carrozzerie_blue.43cffd59.png";